export default __webpack_public_path__ + "static/media/PPI-firefeature-001.70d84983.jpg";